export default {
  GET_PREFERRED_LANES: '@PREFERRED_LANES/GET_PREFERRED_LANES',
  GET_PREFERRED_LANES_SUCCESS: '@PREFERRED_LANES/GET_PREFERRED_LANES_SUCCESS',
  GET_PREFERRED_LANES_FAILURE: '@PREFERRED_LANES/GET_PREFERRED_LANES_FAILURE',

  ADD_PREFERRED_LANE: '@PREFERRED_LANES/ADD_PREFERRED_LANE',
  ADD_PREFERRED_LANE_SUCCESS: '@PREFERRED_LANES/ADD_PREFERRED_LANE_SUCCESS',
  ADD_PREFERRED_LANE_FAILURE: '@PREFERRED_LANES/ADD_PREFERRED_LANE_FAILURE',

  UPDATE_PREFERRED_LANE: '@PREFERRED_LANES/UPDATE_PREFERRED_LANE',
  UPDATE_PREFERRED_LANE_SUCCESS: '@PREFERRED_LANES/UPDATE_PREFERRED_LANE_SUCCESS',
  UPDATE_PREFERRED_LANE_FAILURE: '@PREFERRED_LANES/UPDATE_PREFERRED_LANE_FAILURE',

  DELETE_PREFERRED_LANE: '@PREFERRED_LANES/DELETE_PREFERRED_LANE',
  DELETE_PREFERRED_LANE_SUCCESS: '@PREFERRED_LANES/DELETE_PREFERRED_LANE_SUCCESS',
  DELETE_PREFERRED_LANE_FAILURE: '@PREFERRED_LANES/DELETE_PREFERRED_LANE_FAILURE'
}
